import { emphasisSpans } from '@scripted/shared'

/** Script text with `_emphasis_` shown in italics (same rule the actor app uses). */
export function ScriptText({ text }: { text: string }) {
  return emphasisSpans(text).map((span, i) =>
    // biome-ignore lint/suspicious/noArrayIndexKey: spans are positional
    span.emphasis ? <em key={i}>{span.text}</em> : span.text,
  )
}
